// Accrodian Product Descrption
$( document ).ready(function() {
    var acc = document.getElementsByClassName("ab_accordion");
    var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.display === "block") {
      panel.style.display = "none";
    } else {
      panel.style.display = "block";
    }
  });
}
});

$(document).on('click', ' .slider-button--prev', function(){
   $('.thumbnail-slider li').removeClass('act_option');
});

$(document).on('click', '.slider-button--next', function(){
   $('.thumbnail-slider li').addClass('act_option');
});

$(document).on('click', ' .thumbnail-slider li:nth-child(5), .thumbnail-slider li:nth-child(4)', function(){
   $('.thumbnail-slider li').addClass('act_option');
});

// if (window.innerWidth < 600) {
// $(document).on('click', '.thumbnail-list li', function(){
//         var getId = $(this).attr('data-target');
//         $('.thumbnail-list li button').removeAttr('aria-current');
//         $(this).find('button').attr('aria-current', 'true');
//         $('.product__media-list li').removeClass('is-active');
//         $('.product__media-list li[data-media-id="'+ getId +'"]').addClass('is-active');
  
//        var productMediaList = document.querySelector('.product__media-list');
// var secondItem = productMediaList.querySelector('li[data-media-id="' + getId + '"]');

// var offsetLeft = secondItem.offsetLeft;
// var offsetTop = secondItem.offsetTop;

// productMediaList.scrollTo({
//     left: offsetLeft,
//     top: offsetTop,
//     behavior: 'smooth'
// });
  
//        var currentItem = $(this);

// setTimeout(function() {
//     $('.thumbnail-list li').removeAttr('aria-current');
//     currentItem.find('button').attr('aria-current', 'true');
//     var thumbItem = currentItem[0];
//     thumbItem.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
// }, 1000); 

        
       
// });
// } else {
// $(document).on('click', '.thumb_custom', function(){
//         var getId = $(this).attr('data-target');
//         $('.thumbnail-list li button').removeAttr('aria-current');
//         $(this).find('button').attr('aria-current', 'true');
//         $('.product__media-list li').removeClass('is-active');
//         $('.product__media-list li[data-media-id="'+ getId +'"]').addClass('is-active');
       
// });
// }
 



